"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavExtraHeaderButtons = void 0;
const delete_unavailability_2_1 = require("@app/ac/delete-unavailability-2");
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const UnavExtraHeaderButtons = () => {
    const { formControl, getValues, canEdit, isEmployeeCalendar } = (0, unavailability_context_1.useUnavailability)();
    const dispatch = (0, store_1.useRootDispatch)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const deleteUnavailability = (0, delete_unavailability_2_1.useDeleteUnavailability)();
    const categoryId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'categoryId' });
    const AVAL_OR_UNAV_KEY = `DELETE_UNAV${categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE ? '_AVAIL' : ''}`;
    const isAvailabilityOrUnavailability = [use_workspace_unavailability_categories_1.AVAILABILITY_VALUE, use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE].includes(categoryId ?? '') || typeof categoryId === 'undefined';
    const canDelete = isEmployeeCalendar ? isAvailabilityOrUnavailability : canEdit;
    const requestPendingAction = (0, react_hook_form_1.useWatch)({
        control: formControl,
        name: 'requestPendingAction',
    });
    const isRequest = (0, util_1.isValue)(requestPendingAction);
    return (react_1.default.createElement(ui_1.Tooltip, { key: 'btn-delete', position: ui_1.Tooltip.POSITIONS.BOTTOM, anchor: (isEmployeeCalendar && isRequest) || isRequest ? null : (react_1.default.createElement(ui_1.Icon, { testid: 'delete-timeoff-button', size: ui_1.Icon.SIZES.SMALL, color: ui_1.Icon.COLORS.RED, ico: ui_1.Icon.ICONS.delete, disabled: !canDelete, onClick: async () => {
                await dispatch(deleteUnavailability({
                    details: getValues(),
                    isUnavailability: isAvailabilityOrUnavailability,
                    workspaceId: workspace?.id ?? '',
                }));
            } })) },
        react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.BOTH, size: ui_1.Spacing.SIZES.SIZE_8 }, (0, util_1.t)(AVAL_OR_UNAV_KEY))));
};
exports.UnavExtraHeaderButtons = UnavExtraHeaderButtons;
